exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".btn {\n  margin-top: 1.5rem;\n  margin-bottom: 1.5rem; }\n\n.btn-show {\n  display: block; }\n\n.btn-hide {\n  display: none; }\n\n.btn-rt {\n  right: 0; }\n\n.consultation-container {\n  padding-top: 4rem; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./src/js/views/Consultation/consultation.scss
// module id = 171
// module chunks = 0